import { useEffect, useMemo } from 'react'

import { getPairCatalogSeed } from '@sirius-cybernetics-42/product-config'

import { getActiveChainId } from '@/config/active'
import { syncPairPolicyFromCatalog } from '@/config/marketPolicy'
import type { PairCatalogEntry } from '@/data/marketApi/types'

/**
 * Catálogo declarativo de pares planificados — product-config (flags / identidad).
 * Nutrimatic aporta métricas vía `usePools` / `usePairs`, no el catálogo planificado.
 */
export function usePairCatalog() {
  const chainId = getActiveChainId()

  const entries = useMemo(() => getPairCatalogSeed(chainId), [chainId])

  useEffect(() => {
    syncPairPolicyFromCatalog(chainId, entries)
  }, [chainId, entries])

  return {
    entries,
    isLoading: false,
    isFromApi: false,
  }
}

export function usePairCatalogEntries(): PairCatalogEntry[] {
  return usePairCatalog().entries
}
